<div class="row filter-row align-items-end">
  <div class="col-sm form-group">
    <p>{{'COMMON.ORGANISATIONS' | translate}}</p>
    <select class="form-select form-control" [ngModel]="selectedOrganisation" (ngModelChange)="onOrganisationChanged($event)">
      <option *ngFor="let organisation of organisations" [ngValue]="organisation">{{ organisation.name | translate }}</option>
    </select>
  </div>
  <div class="col-sm form-group">
    <p>{{'COMMON.SITES' | translate}}</p>
    <select class="form-select form-control" [(ngModel)]="selectedSite">
      <option [ngValue]="null">{{'COMMON.ALL' | translate}}</option>
      <option *ngFor="let site of sites" [ngValue]="site">{{ site.name | translate }}</option>
    </select>
  </div>
  <div class="col-sm form-group">
    <button class="btn btn-primary" type="button" (click)="updateSites()">
      {{'COMMON.UPDATE' | translate}}
    </button>
  </div>
</div>

<app-loaders *ngIf="isLoading || isLoadingCharts"></app-loaders>

<div>
  <div class="row" *ngIf="!isLoading">
    <div class="col-12 mb-4" [class.col-md-6]="liveViewData.length > 1"
         *ngFor="let data of liveViewData">
      <app-live-view-counter [liveViewData]="data"
                             [liveViewCounterChartData]="getChartDataForSite(data.id)"
                             [settingsData]="getSettingsForSite(data.id)"></app-live-view-counter>
    </div>
  </div>

  <div class="row" *ngIf="!isLoadingCharts">
    <div class="col-12">
      <app-live-view-charts *ngIf="appliedSite && liveViewChartsData; else noChartData"
                            [liveViewChartsData]="liveViewChartsData"
                            [settingsData]="getSettingsForSite(appliedSite.id)"></app-live-view-charts>
      <ng-template #noChartData>
        <p>{{ 'LIVE_VIEW.NO_CHART_DATA' | translate }}</p>
      </ng-template>
    </div>
  </div>
</div>
